module.exports = __webpack_public_path__ + "static/media/instagram.1fd75deb.png";